import classNames from "classnames";
import { useProgress } from "Contexts/ProgressContext";
import { useVisualContext } from "Contexts/VisualContext";
import React from "react";
import styles from "Styles/components/form-content-wrapper.module.css";
import SVGArrow from "./SVGArrow";
import { motion } from "framer-motion";

const FormContentWrapper = ({
  infoContent,
  formFieldContent,
  formFieldsClassName,
}) => {
  const { backgroundStyle } = useVisualContext();

  const contentInfoClassNames = classNames(styles.formContentInfo, {
    [styles["bg-light"]]: backgroundStyle === "inverted",
  });

  const contentInfoInnerClassNames = classNames(styles.contentInfoInner);

  const contentFieldsClassNames = classNames(
    styles.formContentFields,
    formFieldsClassName,
    {
      [styles["bg-blue"]]: backgroundStyle === "inverted",
    },
  );

  const pageIndicatorWrapperClassNames = classNames(
    styles.pageIndicatorWrapper,
  );

  const pageIndicatorTextClassNames = classNames(styles["pageIndicatorText"]);

  const { currentNavIndex } = useProgress();

  return (
    // <motion.div

    // >
    <motion.div
      key={"formcontentwrapper"}
      className={styles.formContentWrapper}
      exit={{
        opacity: 0,
        y: -400,
        // scale: 0.5,
      }}
      transition={{
        // position: "absolute",
        type: "spring",
        ease: "easeIn",
        duration: 0.6,
        // mass: 1,
      }}
    >
      <div className={contentInfoClassNames}>
        <div className={contentInfoInnerClassNames}>
          {backgroundStyle !== "inverted" ? (
            <div
              className={pageIndicatorWrapperClassNames}
              style={{ display: "flex" }}
            >
              <span className={pageIndicatorTextClassNames}>
                {currentNavIndex}
              </span>
              <SVGArrow
                direction="right"
                variant={2}
                className={styles.arrowSVG}
              />
            </div>
          ) : null}
          {infoContent}
        </div>
      </div>
      <div className={contentFieldsClassNames}>
        <div className={styles.contentFieldsInner}>
          {backgroundStyle === "inverted" ? (
            <div className={pageIndicatorWrapperClassNames}>
              <span className={pageIndicatorTextClassNames}>
                {currentNavIndex}
              </span>
              <SVGArrow
                direction="right"
                variant={2}
                className={styles.arrowSVG}
              />
            </div>
          ) : null}
          {formFieldContent}
        </div>
      </div>
    </motion.div>
    // </motion.div>
  );
};

export default FormContentWrapper;
